const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 142,
    viewBox: "0 0 46 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5834 0V142M22.5834 87.4321C28.0402 81.7273 34.3403 76.9277 36.0393 69.0278C36.5478 66.6714 36.6594 64.1664 36.7338 61.6985C36.895 50.8345 36.957 61.5415 37.081 51M22.4877 54.0461C17.0309 59.7509 10.7308 64.5505 9.03176 72.4504C8.52329 74.8067 8.41168 77.3118 8.33727 79.7797C8.17604 90.6437 8.11404 79.9585 7.99002 90.5M37.1926 51.1334C45.601 50.7738 45.7498 38.5085 37.3166 38C28.561 37.9132 28.2261 50.7242 36.9446 51.1334H37.1926ZM7.87851 90.8666C-0.52988 91.2263 -0.678708 103.492 7.75448 104C16.5101 104.087 16.8449 91.2759 8.12652 90.8666H7.87851Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.d7f47bca35decaa6e63493ac682b3215.svg";
export { ForwardRef as ReactComponent };